import * as apiFactory from "./ApiFactory";
import { Snippet } from "@/models/Snippet";

export async function getAll(clientName: string, brand: string, caseReference: string): Promise<Snippet[]> {
  const client = await apiFactory.WithBearer();
  return await client.get<Snippet[]>(["api/snippet", clientName, brand, caseReference]);
}
export async function getAllByTag(
  clientName: string,
  brand: string,
  caseReference: string,
  tag: string,
): Promise<Snippet[]> {
  const client = await apiFactory.WithBearer();
  return await client.get<Snippet[]>(["api/snippet", clientName, brand, caseReference, tag]);
}
export async function get(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  tag: string,
) {
  const client = await apiFactory.WithBearer();
  return await client.get(["api/snippet", clientName, brand, caseReference, fileReference, tag]);
}
export async function save(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  snippet: Snippet,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.post<Snippet, void>(["api/snippet", clientName, brand, caseReference, fileReference], snippet);
}
export async function deleteSnippet(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  tag: string,
) {
  const client = await apiFactory.WithBearer();
  return await client.delete(["api/snippet", clientName, brand, caseReference, fileReference, tag]);
}
